import { Component } from '@angular/core';
import { Globals } from '../globals/globals';

/**
 * Shown for any address no route matches: the top-level `**` route (outside the app shell)
 * and the last child of the tenant routes (inside it, with the sidebar). The way back is the
 * user's own landing page, never `/` — the empty path renders a blank component.
 */
@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent {

  constructor(private globals: Globals) { }

  /** The signed-in tenant's landing page (the dashboard; users without Dashboard_View see its
   *  welcome message there), or Platform Admin when there is no tenant. */
  get homeLink(): string[] {
    return this.globals.TenantUniqueKey
      ? ['/', this.globals.TenantUniqueKey, 'cloudautomation']
      : ['/platformadmin'];
  }
}
